import { wynnConfig } from './wynn/config';
import { wynnEbhConfig } from './wynn_ebh/config';
import { mgmConfig } from './mgm/config';
import { disneyCruiseConfig } from './disney_cruise/config';

/**
 * Consumer branding configuration.
 * Each consumer has its own folder with a config, theme.scss, and logo.
 */
export interface ConsumerConfig {
  /**
   * CSS class applied to the root container.
   * Matches the .theme-<name> class in idme-assets.
   * The corresponding SCSS file defines all --consumer-* CSS custom properties.
   */
  themeClass: string;
  /** Logo shown at the top of verification cards */
  logo: {
    src: string;
    alt: string;
  };
  /**
   * Brand values documented here for reference — the actual overrides
   * live in the consumer's theme.scss file, not in JavaScript.
   * Source: idme-assets/themes/<name>/_colors.scss and _base.scss
   */
  brand: {
    fontFamily: string;
    colorPrimary: string;
    colorTextPrimary: string;
    colorTextSecondary: string;
  };
  /**
   * Consumer-specific copy for the Legal ID landing screen, as i18n keys in the
   * legal-id locale files so every supported language is covered.
   */
  legalIdIntro?: {
    headingKey: string;
    /** Renders the heading as separate lines (each its own key) instead of headingKey. */
    headingLineKeys?: readonly string[];
    supportingTextKey: string;
    /** Host fallback link; defaults to the generic legalId.ready.fallback. */
    fallbackTextKey?: string;
  };
}

const CONSUMER_CONFIGS: Record<string, ConsumerConfig> = {
  wynn: wynnConfig,
  wynn_ebh: wynnEbhConfig,
  mgm: mgmConfig,
  disney_cruise: disneyCruiseConfig,
};

/** Returns the branding config for the given consumer key, or null if not found. */
export function getConsumerConfig(consumer: string | null): ConsumerConfig | null {
  if (!consumer) return null;
  return CONSUMER_CONFIGS[consumer] ?? null;
}
